export function lastDraft<TEntity, TChange, TDraft>(
  build: (entity: TEntity, changes: TChange[]) => TDraft,
) {
  let last: { entity: TEntity; changes: TChange[]; draft: TDraft } | null = null;
  return (entity: TEntity, changes: TChange[]): TDraft => {
    if (last && last.entity === entity && last.changes === changes) return last.draft;
    const draft = build(entity, changes);
    last = { entity, changes, draft };
    return draft;
  };
}
